import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class RokezzzTitleService {
    private segmentZero: string = 'Rengine';
    private defaultTitle: string;
    private segments: string[] = [];

    public constructor(
        private readonly titleService: Title,
        private readonly meta: Meta,
    ) {
        this.defaultTitle = this.titleService.getTitle();
    }

    public setSegmentZero(segment: string): void {
        this.segmentZero = segment;
    }

    public setFirstSegment(segment: string): void {
        this.segments = [segment];
        this.setTitleFromSegments();
    }

    public setSecondSegment(segment: string): void {
        this.segments = [this.segments[0], segment];
        this.setTitleFromSegments();
    }

    public setThirdSegment(segment: string): void {
        this.segments = [this.segments[0], this.segments[1], segment];
        this.setTitleFromSegments();
    }

    public setDefaultTitle(): void {
        this.setTitle(this.defaultTitle);
    }

    private setTitleFromSegments(): void {
        const segments = [this.segmentZero].concat(this.segments).reverse();

        this.setTitle(segments.join(' | '));
    }

    private setTitle(title: string): void {
        this.titleService.setTitle(title);
        this.meta.updateTag({ property: 'og:title', content: title });
        this.meta.updateTag({ name: 'twitter:title', content: title });
    }
}
